import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FplIfps, formatCtot, getIfpsStateBadge } from "../models/flight";

interface IfpsStateBadgeProps {
  ifps: FplIfps;
}

// Renders the IFPS lifecycle state (filed/queued/acked/rejected/suspended) for an IFR filed FPL.
// CTOT (ATFM slot) is appended to the label when present; ifplId / errors / suggested route
// surface in a tooltip.
function IfpsStateBadge({ ifps }: IfpsStateBadgeProps) {
  const badgeInfo = getIfpsStateBadge(ifps.state);
  const label = badgeInfo.label + (ifps.ctot ? ` · CTOT ${formatCtot(ifps.ctot)}` : "");

  const details: string[] = [];
  if (ifps.ifplId) details.push("IFPL ID: " + ifps.ifplId);
  if (ifps.errors && ifps.errors.length > 0) details.push(...ifps.errors);
  if (ifps.suggestedRoute) details.push("Suggested route: " + ifps.suggestedRoute);

  const badge = (
    <Badge bg={badgeInfo.bg} text={badgeInfo.text} style={badgeInfo.style}>
      {label}
    </Badge>
  );

  if (details.length === 0) {
    return badge;
  }

  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip>
          <div className="p-1 px-2 text-start">
            {details.map((d, i) => (
              <div key={i}>{d}</div>
            ))}
          </div>
        </Tooltip>
      }
    >
      {badge}
    </OverlayTrigger>
  );
}

export default IfpsStateBadge;
